import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

export const _frontmatter = {
  "title": "3-38",
  "description": "Yoga Sutra Chapter 3, Verse 38"
};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <h3 {...{
      "id": "-3-38--"
    }}><a parentName="h3" {...{
        "href": "/Chapter-3/3-37/"
      }}>{`<`}</a>{` 3-38 `}{` `}<a parentName="h3" {...{
        "href": "/Chapter-3/3-39/"
      }}>{`>`}</a></h3>
    <h1 {...{
      "id": "bandha-kāraṇa-śaithilyāt-pracāra-saṃvedanāt-ca-cittasya-para-śarīra-āveśaḥ"
    }}>{`bandha-kāraṇa-śaithilyāt-pracāra-saṃvedanāt-ca cittasya para-śarīra-āveśaḥ`}</h1>
    <h4 {...{
      "id": "relaxation-of-the-cause-for-binding-and-experience-of-maifestation-the-psyche-entering-other-body"
    }}>{`Relaxation of the cause for binding and experience of maifestation, the psyche entering other body`}</h4>
    <br />
    <p><strong parentName="p">{`bandha`}</strong>{` - binding`}</p>
    <p><strong parentName="p">{`kāraṇa`}</strong>{` - reasons, cause`}</p>
    <p><strong parentName="p">{`śaithilya`}</strong>{` - decrease; looseness; relaxation`}</p>
    <p><strong parentName="p">{`pracāra`}</strong>{` - manifestation, appearance, coming forth, spreading`}</p>
    <p><strong parentName="p">{`saṃvedanā`}</strong>{` - to experience; completely knowing`}</p>
    <p><strong parentName="p">{`ca`}</strong>{` - and`}</p>
    <p><strong parentName="p">{`citta`}</strong>{` - psyche (the totality of the human mind, conscious and unconscious); mind; heart`}</p>
    <p><strong parentName="p">{`para`}</strong>{` - higher, other`}</p>
    <p><strong parentName="p">{`śarīra`}</strong>{` - any solid body; bodily frame; one's body`}</p>
    <p><strong parentName="p">{`āveśa`}</strong>{` - entering`}</p>
    <br />

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      